import { ProjectIPDForm } from "@redux/reducers/ipdReducer";

export enum ActionType {
  IPD_DETAIL_BY_PID = "COMMERCIAL_DETAIL_BY_PID",
}
export interface IIPDByPid {
  type: ActionType.IPD_DETAIL_BY_PID;
  payload: ProjectIPDForm[];
}

export type Action = IIPDByPid;
